import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions,
    Button,
    InputLabel,
    MenuItem,
    Select,
    FormControl,
    FormControlLabel,
    FormGroup,
    Typography
} from '@mui/material';
import { fetchInsertAdtCompanies } from '../../../API/AdtimizerReport';
import useApi from '../../../hooks/useApi';
import { IOSSwitch } from '../../../components/UI/CustomizedSwitches';

function EditInsertBundleDialog({ open, handleClose, data, onChange, onSave }) {

    const {data: adtCompanies, loading: loadingAdtCompanies} = useApi(fetchInsertAdtCompanies);

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Edit {data.company_name}</DialogTitle>
            <DialogContent sx={{ minWidth: '450px' }}>
                <TextField fullWidth margin="dense" name="bandle_name" label="Bandle Name" value={data.bandle_name} onChange={onChange} />

                <FormControl fullWidth margin="dense">
                    <InputLabel id="adt_id">ADT Company ID</InputLabel>
                    <Select
                        labelId="adt_id"
                        id="adt_id"
                        name="adt_id"
                        value={data.adt_id}
                        onChange={onChange}
                        required
                        label="ADT Company ID"
                    >
                        {adtCompanies.map((item) => (
                            <MenuItem key={item.value.id} value={item.value.id}>
                                {item.value.company_name} (ID: {item.value.id})
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl fullWidth margin="dense">
                    <InputLabel id="type">Type</InputLabel>
                    <Select
                        labelId="type"
                        name="type"
                        label="Type"
                        value={data.type}
                        onChange={onChange}
                    >
                        <MenuItem value="Android">Android</MenuItem>
                        <MenuItem value="IOS">IOS</MenuItem>
                        <MenuItem value="WEB">WEB</MenuItem>
                        <MenuItem value="CTV">CTV</MenuItem>
                    </Select>
                </FormControl>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={onSave}>Save</Button>
            </DialogActions>
        </Dialog>
    );
}

export default EditInsertBundleDialog;
